(function () {
  "use strict";

  if (window.__rehairAdsTrackingInstalled) return;
  window.__rehairAdsTrackingInstalled = true;

  var GOOGLE_ADS_ID = "AW-10793238073";
  var GA_MEASUREMENT_ID = "G-FYF81RGLBM";
  var GA_SESSION_COOKIE = "_ga_" + GA_MEASUREMENT_ID.replace(/^G-/, "");
  var QUOTE_SEND_TO = "AW-10793238073/9GSZCLvxxNYcELn8zpoo";
  var WHATSAPP_SEND_TO = "AW-10793238073/I_5oCL7xxNYcELn8zpoo";
  var ATTRIBUTION_COOKIE = "rehair_google_ads_attribution";
  var ATTRIBUTION_MAX_AGE_SECONDS = 90 * 24 * 60 * 60;
  var ATTRIBUTION_MAX_AGE_MS = ATTRIBUTION_MAX_AGE_SECONDS * 1000;
  var CLICK_ID_KEYS = ["gclid", "gbraid", "wbraid"];
  var CAMPAIGN_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
  ];
  var ATTRIBUTION_KEYS = CLICK_ID_KEYS.concat(CAMPAIGN_KEYS);
  var QUOTE_PROPERTY_PREFIX = "_google_ads_";

  var privacyReady = false;
  var googleTagConfigured = false;
  var quoteTracked = false;
  var pendingConversions = [];
  var attribution = {};
  var gaCartSyncInFlight = false;

  function marketingAllowed() {
    if (!privacyReady) return false;

    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== "function") {
      return true;
    }

    try {
      return privacy.marketingAllowed();
    } catch (_error) {
      return false;
    }
  }

  function trackingAllowed() {
    if (!marketingAllowed()) return false;

    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;

    try {
      return (
        typeof privacy.analyticsProcessingAllowed !== "function" ||
        privacy.analyticsProcessingAllowed()
      );
    } catch (_error) {
      return false;
    }
  }

  function validClickId(value) {
    return (
      typeof value === "string" &&
      value.length > 0 &&
      value.length <= 512 &&
      /^[A-Za-z0-9._~-]+$/.test(value)
    );
  }

  function validCampaignValue(value) {
    return (
      typeof value === "string" &&
      value.length > 0 &&
      value.length <= 512 &&
      !/[\u0000-\u001f\u007f]/.test(value)
    );
  }

  function currentAttribution() {
    var params = new URLSearchParams(window.location.search);
    var result = {};

    CLICK_ID_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (validClickId(value)) result[key] = value;
    });
    CAMPAIGN_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (validCampaignValue(value)) result[key] = value;
    });

    if (!Object.keys(result).length) return null;

    result.captured_at = new Date().toISOString();
    result.landing_page = window.location.pathname || "/";
    return result;
  }

  function validStoredAttribution(value) {
    if (!value || typeof value !== "object") return {};

    var result = {};
    CLICK_ID_KEYS.forEach(function (key) {
      if (validClickId(value[key])) result[key] = value[key];
    });
    CAMPAIGN_KEYS.forEach(function (key) {
      if (validCampaignValue(value[key])) result[key] = value[key];
    });

    if (!Object.keys(result).length) return {};

    var capturedAt = Date.parse(value.captured_at);
    if (
      !Number.isFinite(capturedAt) ||
      Date.now() - capturedAt > ATTRIBUTION_MAX_AGE_MS
    ) {
      return {};
    }

    result.captured_at = value.captured_at;
    if (
      typeof value.landing_page === "string" &&
      value.landing_page.charAt(0) === "/" &&
      value.landing_page.length <= 500
    ) {
      result.landing_page = value.landing_page;
    }
    return result;
  }

  function readAttributionCookie() {
    if (!marketingAllowed()) return {};

    var prefix = ATTRIBUTION_COOKIE + "=";
    var cookies = document.cookie ? document.cookie.split(";") : [];

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();
      if (cookie.indexOf(prefix) !== 0) continue;

      try {
        return validStoredAttribution(
          JSON.parse(decodeURIComponent(cookie.slice(prefix.length)))
        );
      } catch (_error) {
        return {};
      }
    }

    return {};
  }

  function writeAttributionCookie(value) {
    if (!marketingAllowed()) return;

    var parts = [
      ATTRIBUTION_COOKIE +
        "=" +
        encodeURIComponent(JSON.stringify(value)),
      "path=/",
      "max-age=" + ATTRIBUTION_MAX_AGE_SECONDS,
      "SameSite=Lax",
    ];
    if (window.location.protocol === "https:") parts.push("Secure");
    document.cookie = parts.join("; ");
  }

  function readCookie(name) {
    var prefix = name + "=";
    var cookies = document.cookie ? document.cookie.split(";") : [];

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();
      if (cookie.indexOf(prefix) === 0) {
        return decodeURIComponent(cookie.slice(prefix.length));
      }
    }
    return "";
  }

  function googleClientId() {
    var parts = readCookie("_ga").split(".");
    if (parts.length < 4) return "";

    var value = parts.slice(-2).join(".");
    return /^\d{1,20}\.\d{1,20}$/.test(value) ? value : "";
  }

  function googleSessionId() {
    var value = readCookie(GA_SESSION_COOKIE);
    if (!value) return "";

    var current = value.match(/(?:^|\.)s(\d{6,})(?:\$|\.|$)/);
    if (current) return current[1];

    var legacy = value.match(/^GS\d+\.\d+\.(\d{6,})(?:\.|$)/);
    return legacy ? legacy[1] : "";
  }

  // ReHair GA cart sync v2: draft-only reliability patch; consent policy unchanged.
  var gaCartSyncTimers = [];
  var gaCartSyncDebounce = null;
  var gaCartEventSubscribed = false;

  function gaCartRequest(url, options) {
    var controller = typeof window.AbortController === "function"
      ? new window.AbortController() : null;
    var timer;
    var timeout = new Promise(function (_resolve, reject) {
      timer = window.setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error("cart sync timeout"));
      }, 4000);
    });
    var request = Object.assign({}, options);
    if (controller) request.signal = controller.signal;
    return Promise.race([
      Promise.resolve().then(function () { return window.fetch(url, request); })
        .then(function (response) {
          if (!response.ok) throw new Error("cart sync request failed");
          return response.json();
        }),
      timeout,
    ]).then(function (cart) {
      window.clearTimeout(timer);
      return cart;
    }, function (error) {
      window.clearTimeout(timer);
      throw error;
    });
  }

  function syncGaCartAttributes() {
    installGaCartHooks();
    if (!trackingAllowed() || typeof window.fetch !== "function" || gaCartSyncInFlight) return;
    var clientId, sessionId;
    try {
      clientId = googleClientId();
      sessionId = googleSessionId();
    } catch (_error) { return; }
    if (!clientId || !sessionId) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    gaCartSyncInFlight = true;
    gaCartRequest(root + "cart.js", {
      method: "GET", credentials: "same-origin", cache: "no-store",
      headers: { Accept: "application/json" },
    }).then(function (cart) {
      // Recheck consent and identity after the asynchronous read, before any write.
      if (!trackingAllowed() || clientId !== googleClientId() || sessionId !== googleSessionId()) return;
      if (!cart || !cart.attributes || typeof cart.attributes !== "object") return;
      if (cart.attributes.rehair_ga_client_id === clientId &&
          String(cart.attributes.rehair_ga_session_id || "") === sessionId) return;
      return gaCartRequest(root + "cart/update.js", {
        method: "POST", credentials: "same-origin", keepalive: true,
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: {
          rehair_ga_client_id: clientId,
          rehair_ga_session_id: sessionId,
          rehair_ga_captured_at: new Date().toISOString(),
        } }),
      });
    }).catch(function () {
      // Best effort only: never reject or pause the shopper's checkout action.
    }).then(function () { gaCartSyncInFlight = false; });
  }

  function queueGaCartSync() {
    if (gaCartSyncDebounce !== null) window.clearTimeout(gaCartSyncDebounce);
    gaCartSyncDebounce = window.setTimeout(function () {
      gaCartSyncDebounce = null;
      syncGaCartAttributes();
    }, 200);
  }

  function installGaCartHooks() {
    if (gaCartEventSubscribed) return;
    var bus = window.MinimogEvents;
    var events = window.MinimogTheme && window.MinimogTheme.pubSubEvents;
    if (bus && typeof bus.subscribe === "function" && events && events.cartUpdate) {
      bus.subscribe(events.cartUpdate, queueGaCartSync);
      gaCartEventSubscribed = true;
    }
  }

  function syncGaOnCheckoutIntent(event) {
    var target = event.target && event.target.closest && event.target.closest(
      '[name="checkout"], a[href*="/checkout"], .shopify-payment-button, form[action*="/cart"]'
    );
    if (target) syncGaCartAttributes();
    // Deliberately no preventDefault, stopPropagation or awaited navigation.
  }

  function scheduleGaCartSync() {
    gaCartSyncTimers.forEach(function (timer) { window.clearTimeout(timer); });
    gaCartSyncTimers = [];
    syncGaCartAttributes();
    if (!trackingAllowed()) return;
    [2000, 8000, 15000, 30000, 60000].forEach(function (delay) {
      gaCartSyncTimers.push(window.setTimeout(syncGaCartAttributes, delay));
    });
  }

  document.addEventListener("cart:updated", queueGaCartSync);
  document.addEventListener("cart:refresh", queueGaCartSync);
  document.addEventListener("pointerdown", syncGaOnCheckoutIntent, true);
  document.addEventListener("click", syncGaOnCheckoutIntent, true);
  document.addEventListener("submit", syncGaOnCheckoutIntent, true);
  window.addEventListener("pageshow", scheduleGaCartSync);
  window.addEventListener("focus", queueGaCartSync);


  function attributionPayload(payload) {
    var result = Object.assign({}, payload);
    if (!marketingAllowed()) return result;

    ATTRIBUTION_KEYS.forEach(function (key) {
      if (attribution[key]) result[key] = attribution[key];
    });
    if (attribution.captured_at) {
      result.attribution_captured_at = attribution.captured_at;
    }
    if (attribution.landing_page) {
      result.attribution_landing_page = attribution.landing_page;
    }
    return result;
  }

  function syncQuoteSnapAttribution() {
    if (!marketingAllowed()) return;

    var productId = window.__st && window.__st.rid;
    var products = window.omgrfq_productCollection;
    var product = products && productId && products[productId];
    if (!product || !Object.keys(attribution).length) return;

    var properties = Object.assign({}, product.properties || {});
    ATTRIBUTION_KEYS.forEach(function (key) {
      delete properties[QUOTE_PROPERTY_PREFIX + key];
      if (attribution[key]) {
        properties[QUOTE_PROPERTY_PREFIX + key] = attribution[key];
      }
    });

    if (attribution.captured_at) {
      properties[QUOTE_PROPERTY_PREFIX + "captured_at"] =
        attribution.captured_at;
    }
    if (attribution.landing_page) {
      properties[QUOTE_PROPERTY_PREFIX + "landing_page"] =
        attribution.landing_page;
    }
    product.properties = properties;
  }

  function captureAttribution() {
    if (!marketingAllowed()) return;

    var stored = readAttributionCookie();
    var current = currentAttribution();
    attribution = current
      ? Object.assign({}, stored, current)
      : stored;
    if (current) writeAttributionCookie(attribution);
    syncQuoteSnapAttribution();
  }

  function ensureGoogleTag() {
    if (!trackingAllowed()) return false;

    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };

    if (
      !document.querySelector(
        'script[data-rehair-google-ads-tag="' + GOOGLE_ADS_ID + '"]'
      )
    ) {
      var script = document.createElement("script");
      script.async = true;
      script.src =
        "https://www.googletagmanager.com/gtag/js?id=" + GOOGLE_ADS_ID;
      script.dataset.rehairGoogleAdsTag = GOOGLE_ADS_ID;
      document.head.appendChild(script);
    }

    if (!googleTagConfigured) {
      window.gtag("js", new Date());
      window.gtag("config", GOOGLE_ADS_ID);
      googleTagConfigured = true;
    }

    return true;
  }

  function publishShopifyEvent(name, payload) {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === "function"
      ) {
        var result = window.Shopify.analytics.publish(
          "rehair:" + name,
          payload
        );
        if (result && typeof result.catch === "function") {
          result.catch(function () {});
        }
      }
    } catch (_error) {}
  }

  function emitConversion(conversion) {
    if (!ensureGoogleTag()) {
      pendingConversions.push(conversion);
      return;
    }

    var payload = attributionPayload(conversion.payload);
    publishShopifyEvent(conversion.name, payload);
    window.dataLayer.push(
      attributionPayload({
        event: conversion.name,
        event_id: payload.event_id,
        page_path: payload.page_path,
      })
    );

    var googlePayload = { send_to: conversion.sendTo };
    if (payload.transaction_id) {
      googlePayload.transaction_id = payload.transaction_id;
    }
    window.gtag("event", "conversion", googlePayload);
  }

  function flushPendingConversions() {
    if (!trackingAllowed() || !pendingConversions.length) return;

    var queued = pendingConversions.slice();
    pendingConversions = [];
    queued.forEach(emitConversion);
  }

  function createEventId(prefix) {
    var suffix =
      window.crypto && typeof window.crypto.randomUUID === "function"
        ? window.crypto.randomUUID()
        : String(Date.now()) + "_" + Math.random().toString(36).slice(2);
    return prefix + "_" + suffix;
  }

  function pagePath() {
    return window.location.pathname + window.location.search;
  }

  function trackQuoteSuccess() {
    if (quoteTracked) return;

    var success = document.querySelector(
      ".omgrfq-submit-success #omg-confirmation-message, " +
        ".omgrfq-submit-success"
    );
    if (!success) return;

    quoteTracked = true;
    var eventId = createEventId("quote");
    emitConversion({
      name: "inquiry_quote_submitted",
      sendTo: QUOTE_SEND_TO,
      payload: {
        event_id: eventId,
        transaction_id: eventId,
        page_path: pagePath(),
        product_id:
          document.body && document.body.getAttribute("data-product-id"),
      },
    });
  }

  function isWhatsAppLink(anchor) {
    var href = anchor.getAttribute("href") || "";
    if (/^whatsapp:/i.test(href)) return true;

    try {
      var hostname = new URL(href, window.location.href).hostname
        .toLowerCase()
        .replace(/^www\./, "");
      return hostname === "wa.me" || hostname.endsWith(".whatsapp.com");
    } catch (_error) {
      return false;
    }
  }

  function trackWhatsAppClick(event) {
    var anchor = event.target.closest && event.target.closest("a[href]");
    if (!anchor || !isWhatsAppLink(anchor)) return;

    emitConversion({
      name: "whatsapp_click",
      sendTo: WHATSAPP_SEND_TO,
      payload: {
        event_id: createEventId("whatsapp"),
        page_path: pagePath(),
      },
    });
  }

  function trackQuoteAttribution(event) {
    var target =
      event.target.closest &&
      event.target.closest(".omgrfq-btn-quotes, .omgrfq-btn-add-quotes");
    if (!target) return;

    captureAttribution();
    syncQuoteSnapAttribution();
  }

  function trackGuidedShoppingClick(event) {
    var target =
      event.target.closest && event.target.closest("[data-rehair-event]");
    if (!target) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      attributionPayload({
        event: target.getAttribute("data-rehair-event"),
        guided_shopping_location: window.location.pathname,
        guided_shopping_destination: target.getAttribute("href") || "",
      })
    );
  }

  function privacyInitialized() {
    privacyReady = true;
    captureAttribution();
    if (trackingAllowed()) ensureGoogleTag();
    scheduleGaCartSync();
    flushPendingConversions();
  }

  function initializePrivacy() {
    if (
      window.Shopify &&
      typeof window.Shopify.loadFeatures === "function" &&
      !window.Shopify.customerPrivacy
    ) {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        privacyInitialized
      );
      return;
    }

    privacyInitialized();
  }

  document.addEventListener("visitorConsentCollected", privacyInitialized);
  document.addEventListener("trackingConsentAccepted", privacyInitialized);
  document.addEventListener("click", trackWhatsAppClick, true);
  document.addEventListener("click", trackQuoteAttribution, true);
  document.addEventListener("click", trackGuidedShoppingClick, true);

  new MutationObserver(trackQuoteSuccess).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  initializePrivacy();
  trackQuoteSuccess();
})();
